import MotionController from "../lib/motion_controller"
import { gsap, FINE_POINTER } from "../lib/motion"

// Subtle magnetic pull toward the cursor (CTA buttons). Bounds are measured once on
// pointerenter so pointermove never forces layout.
export default class extends MotionController {
  static values = { strength: { type: Number, default: 0.2 } }

  animate({ desktop }) {
    if (!desktop || !window.matchMedia(FINE_POINTER).matches) return

    const x = gsap.quickTo(this.element, "x", { duration: 0.6, ease: "power3.out" })
    const y = gsap.quickTo(this.element, "y", { duration: 0.6, ease: "power3.out" })
    let bounds = null

    const enter = () => { bounds = this.element.getBoundingClientRect() }
    const move = (event) => {
      if (!bounds) enter()
      x((event.clientX - (bounds.left + bounds.width / 2)) * this.strengthValue)
      y((event.clientY - (bounds.top + bounds.height / 2)) * this.strengthValue)
    }
    const leave = () => { bounds = null; x(0); y(0) }

    this.element.addEventListener("pointerenter", enter)
    this.element.addEventListener("pointermove", move)
    this.element.addEventListener("pointerleave", leave)

    return () => {
      this.element.removeEventListener("pointerenter", enter)
      this.element.removeEventListener("pointermove", move)
      this.element.removeEventListener("pointerleave", leave)
    }
  }
}
